// ============================================================================
// DATI DELL'AZIENDA CHE HA SVILUPPATO SEDIO
// ⚠️ COMPILA QUI I DATI REALI: sono usati in tutti i documenti legali (/legale).
// Sostituisci i valori tra [ ] con quelli corretti. Modifica SOLO questo file.
// ============================================================================
export const COMPANY = {
  nome_prodotto: "Sedio",
  ragione_sociale: "Nenyre Group S.r.l.s.",
  partita_iva: "05008770231",
  codice_fiscale: "05008770231",
  sede_legale: "Via Antonio Pisano 7/B, 37131 Verona (VR)",
  email: "sedio@nenyre.it",
  pec: "nenyre@pec.it",
  telefono: "",
  sito_web: "www.sedio.it",
  // Data di ultimo aggiornamento mostrata nei documenti
  ultimo_aggiornamento: "giugno 2026",
};

// Ritorna la ragione sociale o un fallback leggibile se non ancora compilata
export const companyLabel = () =>
  COMPANY.ragione_sociale && !COMPANY.ragione_sociale.startsWith("[")
    ? COMPANY.ragione_sociale
    : "il Fornitore del servizio Sedio";
